import { request, getJSON } from "./request";
export const getUserInfo = () => {
  return request(`/v1/user`, "get", { params: { is_teacher: true } });
};
// 发送验证码
export const sendCode = (params) => {
  return request("/v1/auth/sendCode", "post", { json: params });
};
export const authLogout = (params) => {
  return request("/v1/auth/logout", "post", { json: params });
};
export const weChatShare = (params) => {
  return request(`/v1/wechat/share`, "get", { params });
};

export const getDownloadConfig = (params) => {
  let fileName = "downloadConfig.json";
  // 非生产环境使用测试配置
  if (process.env.VUE_APP_ENV !== 'production') {
    fileName = "downloadConfig-test.json";
  }
  return getJSON(`${process.env.VUE_APP_CDN_URL}/cdn/saas-desktop/${fileName}`);
};

export const getAndroidAppVersion = (params) => {
  return request(`/v1/appVersion/get/android`, "get", { params });
};
export const getIosAppVersion = (params) => {
  return request(`/v1/appVersion/get/ios`, "get", { params });
};
